import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "reset-shell" }
const _hoisted_2 = { class: "reset-card" }
const _hoisted_3 = {
  key: 0,
  class: "invalid-state"
}
const _hoisted_4 = {
  key: 1,
  class: "success-state"
}
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = {
  key: 0,
  class: "error-text"
}
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "reset-title" }, "Nova senha", -1)),
      (!_ctx.token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "invalid-text" }, "Link inválido. Verifique o e-mail ou solicite um novo link.", -1)),
            _createElementVNode("button", {
              class: "btn-primary",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/forgot')))
            }, "Solicitar novo link")
          ]))
        : (_ctx.done)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                width: "48",
                height: "48",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#1f8a45",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
                _createElementVNode("polyline", { points: "22 4 12 14.01 9 11.01" })
              ], -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "success-text" }, "Senha atualizada com sucesso!", -1)),
              _createElementVNode("button", {
                class: "btn-primary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/')))
              }, "Ir para login")
            ]))
          : (_openBlock(), _createElementBlock("form", {
              key: 2,
              class: "reset-form",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "reset-desc" }, "Escolha uma nova senha para sua conta. Mínimo de 8 caracteres com pelo menos um número.", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { for: "rs-password" }, "Nova senha", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "rs-password",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
                  type: "password",
                  placeholder: "••••••••",
                  autocomplete: "new-password"
                }, null, 512), [
                  [_vModelText, _ctx.newPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { for: "rs-confirm" }, "Confirmar senha", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "rs-confirm",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  type: "password",
                  placeholder: "••••••••",
                  autocomplete: "new-password"
                }, null, 512), [
                  [_vModelText, _ctx.confirmPassword]
                ])
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn-primary",
                type: "submit",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? 'Salvando...' : 'Definir nova senha'), 9, _hoisted_8)
            ], 32))
    ])
  ]))
}